<template>
  <li :class="{ current: active }">
    <router-link id="href-venues" :to="{ name: 'BookingVenues' }">
      <i class="fa fa-fw fa-lg fa-map-marker"></i>Venues&nbsp;
      <span
        class="badge badge-new-bookings"
        data-toggle="tooltip"
        data-placement="right"
        :title="`Has ${totalCount} new booking`"
        >{{ totalCount }}</span
      >
    </router-link>
    <div class="grid-container3 submenu hidden-xs" v-if="isVenuesOnFirstLevel">
      <div class="grid-column grid-column3">
        <ul>
          <li v-for="venue in venues" :key="venue.id">
            <router-link
              :to="{
                name: 'VenueCalendar',
                params: { id: venue.id }
              }"
              :id="'href-venue-' + venue.id"
              class="text-overflow-ellipsis"
            >
              <p class="sup-facility" v-if="venue.facility">
                <b>{{ venue.facility.name }}</b>
              </p>
              {{ venue.name }}
              <i
                class="fa fa-indicator fa-chevron-right"
                style="font-size: 12px; margin: 0 0 0 5px;"
                v-show="venue.child_venues && venue.child_venues.length"
              ></i>
            </router-link>
            <div
              class="grid-container3"
              v-if="venue.child_venues && venue.child_venues.length"
            >
              <ul>
                <li
                  v-for="childVenue in venue.child_venues"
                  :key="childVenue.id"
                >
                  <router-link
                    :to="{
                      name: 'VenueCalendar',
                      params: { id: childVenue.id }
                    }"
                    :id="'href-venue-' + childVenue.id"
                    class="text-overflow-ellipsis"
                  >
                    {{ childVenue.name }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="submenu hidden-xs" v-else>
      <ul class="grid-column grid-column12">
        <li
          class="grid-column grid-column4"
          v-for="facility in facilities"
          :key="facility.id"
        >
          <router-link to="">
            {{ facility.name }}
            <i
              class="fa fa-indicator fa-chevron-right"
              style="font-size: 12px; margin: 0 0 0 5px;"
              v-if="facility.venues.length"
            ></i>
          </router-link>
          <div class="grid-container3" v-if="facility.venues.length">
            <ul>
              <li v-for="venue in facility.venues" :key="venue.id">
                <router-link
                  :to="{
                    name: 'VenueCalendar',
                    params: { id: venue.id }
                  }"
                  :id="'href-venue-' + venue.id"
                >
                  {{ venue.name }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </li>
</template>

<script>
import Api from "@/api.js";

export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      venues: [],
      totalCount: null,
      facilities: [],
      isVenuesOnFirstLevel: false,
      venues_menu_template: null
    };
  },

  created() {
    this.venues_menu_template = this.$appConfigs().venues_menu_template;
  },

  watch: {
    venues_menu_template(template) {
      const endpoint = this.$partnerEndpoint(
        "venues/menu-templates/" + template
      );
      this.isVenuesOnFirstLevel = template.split("_")[0] === "venues";

      Api()
        .get(endpoint)
        .then(response => {
          if (this.isVenuesOnFirstLevel) {
            if (template === "venues_on_first_level") {
              const allVenues = [];
              response.data.data.map(venue => {
                allVenues.push({ id: venue.id, name: venue.name });
                if (venue.child_venues && venue.child_venues.length) {
                  venue.child_venues.map(childVenue => {
                    allVenues.push(childVenue);
                  });
                }
              });
              this.venues = allVenues;
              this.totalCount = this.venues.length;
            } else {
              this.venues = response.data.data;
              this.totalCount = this.venues.length;
              this.venues.map(venue => {
                if (venue.child_venues && venue.child_venues.length) {
                  this.totalCount += venue.child_venues.length;
                }
              });
            }
          } else {
            this.facilities = response.data.data;
            this.totalCount = 0;
            this.facilities.map(facility => {
              this.totalCount += facility.venues.length;
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style>
.sup-facility {
  color: #0088cc;
  font-size: 10px;
}

.text-overflow-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
